import { Children, cloneElement, Component, isValidElement } from 'react';
import { isDropdownItemCompatible } from '../DropdownItem';
import { List } from '../List';
import { InputValue } from '../types';

export interface MenuListProps {
    onItemClick?: (e: React.MouseEvent, value: InputValue) => void;
}

interface ChildProps {
    onAfterClick?: MenuListProps['onItemClick'];
    tabIndex?: number;
}

export class MenuInnerList extends Component<React.PropsWithChildren<MenuListProps>> {
    render() {
        const { onItemClick, children, ...other } = this.props;

        const items = Children.map(children, (c) => {
            if (!isValidElement<ChildProps>(c)) {
                return c;
            }

            // Only apply onAfterClick to dropdown-compatible components
            if (isDropdownItemCompatible(c)) {
                return cloneElement(c, {
                    ...(!!onItemClick && { onAfterClick: onItemClick }),
                    tabIndex: c.props.tabIndex ?? -1,
                });
            }

            return c;
        });

        return <List {...other}>{items}</List>;
    }
}

export default MenuInnerList;
